import * as ViewManagementModule from 'Modules/ViewManagementModule';
import * as Dictionary from 'Models/Dictionary';
import * as ActionTypes from './EnumTypes/ActionEnumTypes';
import * as ViewsManagementModel from './Models/ViewsManagementActionModel';
import * as Types from 'Models/ViewManagementModel';
import * as HistoryEnumTypes from 'Models/EnumTypes/HistoryEnumTypes';
import * as AOIModule from 'Modules/AOIModule';
import * as POIModule from 'Modules/POIModule';
import * as NotificationModule from 'Modules/NotificationModule';
import * as ErrorActions from './ErrorActions';
import i18n from 'Translations/_i18n';
import {history} from 'HelperFunctions/root';

function showLoader(): ViewsManagementModel.ShowLoader {
  return {
    type: ActionTypes.ViewManagement.SHOW_LOADER
  };
}

function hideLoader(): ViewsManagementModel.HideLoader {
  return {
    type: ActionTypes.ViewManagement.HIDE_LOADER
  };
}

function toggleSidebarMenu(): ViewsManagementModel.ToggleSidebarMenu {
  return {
    type: ActionTypes.ViewManagement.TOGGLE_SIDEBAR_MENU
  };
}

function showDetailsPanel(): ViewsManagementModel.ShowDetailsPanel {
  return {
    type: ActionTypes.ViewManagement.SHOW_DETAILS_PANEL
  };
}

function toggleDetailsPanel(): ViewsManagementModel.ToggleDetailsPanel {
  return {
    type: ActionTypes.ViewManagement.TOGGLE_DETAILS_PANEL
  };
}

function hideDetailsPanel(): ViewsManagementModel.HideDetailsPanel {
  return {
    type: ActionTypes.ViewManagement.HIDE_DETAILS_PANEL
  };
}

function setActivePage(activePage: Types.Page, redirect = false) {
  return async dispatch => {
    if (redirect) {
      history.push(activePage.url);
    }
    if (activePage.title !== Dictionary.PageDetails.get(ViewManagementModule.EnumTypes.Page.MAP).title) {
      dispatch(NotificationModule.Actions.setActiveNotification(null));
    }
    dispatch(ErrorActions.clearErrorStore());
    document.title = `${i18n.t(`mainMenu:${activePage.title}`)} | GPS Tracking`;
    dispatch(setActivePageSuccess(activePage));
  };
}

function setActivePageSuccess(activePage: Types.Page): ViewsManagementModel.SetActivePage {
  return {
    type: ActionTypes.ViewManagement.SET_ACTIVE_PAGE,
    payload: activePage
  };
}

function setLanguage(activeLanguage: string): ViewsManagementModel.SetLanguage {
  return {
    type: ActionTypes.ViewManagement.SET_LANGUAGE,
    payload: {
      activeLanguage
    }
  };
}

function showCarRideDetailsView(): ViewsManagementModel.ShowCarRideDetailsView {
  return {
    type: ActionTypes.ViewManagement.SHOW_CARRIDE_DETAILS_VIEW
  };
}

function hideCarRideDetailsView(): ViewsManagementModel.HideCarRideDetailsView {
  return {
    type: ActionTypes.ViewManagement.HIDE_CARRIDE_DETAILS_VIEW
  };
}

function SetActiveRideViewType(activeRideView: HistoryEnumTypes.RideViewType): ViewsManagementModel.SetActiveRideViewType {
  return {
    type: ActionTypes.ViewManagement.SET_ACTIVE_RIDE_VIEW_TYPE,
    payload: {
      activeRideView
    }
  };
}

function setActiveCarDetailsView(activeCarDetailsView: HistoryEnumTypes.CarDetailsViewType): ViewsManagementModel.SetActiveCarDetailsView {
  return {
    type: ActionTypes.ViewManagement.SET_ACTIVE_CAR_DETAILS_VIEW,
    payload: {
      activeCarDetailsView
    }
  };
}

function SetActiveZoneView(activeZoneView: HistoryEnumTypes.ZonesViewType): ViewsManagementModel.SetActiveZoneView {
  return {
    type: ActionTypes.ViewManagement.SET_ACTIVE_ZONE_VIEW,
    payload: {
      activeZoneView
    }
  };
}

function toggleAddingAOI(): ViewsManagementModel.ToggleAddingAOI {
  return {
    type: ActionTypes.ViewManagement.TOGGLE_ADDING_AOI
  };
}

function showAddingAOISuccess(): ViewsManagementModel.ShowAddingAOI {
  return {
    type: ActionTypes.ViewManagement.SHOW_ADDING_AOI
  };
}

function showAddingPOI(): ViewsManagementModel.ShowAddingPOI {
  return {
    type: ActionTypes.ViewManagement.SHOW_ADDING_POI
  };
}

function hideAddingPOI(): ViewsManagementModel.HideAddingPOI {
  return {
    type: ActionTypes.ViewManagement.HIDE_ADDING_POI
  };
}

function showAddingAOI() {
  return async dispatch => {
    dispatch(showAddingAOISuccess());
    dispatch(AOIModule.Actions.hideAoiDetailsPopup());
    dispatch(AOIModule.Actions.setDetailsForAoiView(null));
  };
}

function hideAddingPOIAndWipeCoords() {
  return async dispatch => {
    dispatch(POIModule.Actions.addPoiPopupPosition(null));
    dispatch(hideAddingPOI());
  };
}

function hideAddingAOI(): ViewsManagementModel.HideAddingAOI {
  return {
    type: ActionTypes.ViewManagement.HIDE_ADDING_AOI
  };
}

function hideAddingAOIandWipeCoords() {
  return async dispatch => {
    dispatch(AOIModule.Actions.clearCoordsOfNewZone());
    dispatch(hideAddingAOI());
  };
}

function showVehicleList(): ViewsManagementModel.ShowVehicleList {
  return {
    type: ActionTypes.ViewManagement.SHOW_VEHICLE_LIST
  };
}

function hideVehicleList(): ViewsManagementModel.HideVehicleList {
  return {
    type: ActionTypes.ViewManagement.HIDE_VEHICLE_LIST
  };
}

function showPopup(popupData: Types.Popup): ViewsManagementModel.ShowPopup {
  return {
    type: ActionTypes.ViewManagement.SHOW_POPUP,
    payload: {
      popupData
    }
  };
}

function summaryMapManage(type: 'car' | 'poi' | 'aoi' | 'alert'): ViewsManagementModel.ManageMapSummary {
  return {
    type: ActionTypes.ViewManagement.MANAGE_MAP_SUMMARY,
    payload: {
      type
    }
  };
}

function showZones(): ViewsManagementModel.ShowZones {
  return {
    type: ActionTypes.ViewManagement.SHOW_ZONES
  };
}

function hidePopup(): ViewsManagementModel.HidePopup {
  return {
    type: ActionTypes.ViewManagement.HIDE_POPUP
  };
}

function changeAlertListType(type: Types.AlertListTypeVisible): ViewsManagementModel.ChangeAlertListType {
  return {
    type: ActionTypes.ViewManagement.CHANGE_ALERT_LIST_TYPE,
    payload: {
      type
    }
  };
}

function showDetailsSidebarLoader(): ViewsManagementModel.ShowDetailsSidebarLoader {
  return {
    type: ActionTypes.ViewManagement.SHOW_DETAILS_SIDEBAR_LOADER
  };
}

function hideDetailsSidebarLoader(): ViewsManagementModel.HideDetailsSidebarLoader {
  return {
    type: ActionTypes.ViewManagement.HIDE_DETAILS_SIDEBAR_LOADER
  };
}

function showAlerts(): ViewsManagementModel.ShowAlerts {
  return {
    type: ActionTypes.ViewManagement.SHOW_ALERTS
  };
}

export {
  showLoader,
  hideLoader,
  toggleSidebarMenu,
  showDetailsPanel,
  hideDetailsPanel,
  toggleDetailsPanel,
  setActivePage,
  setLanguage,
  showCarRideDetailsView,
  hideCarRideDetailsView,
  SetActiveRideViewType,
  SetActiveZoneView,
  toggleAddingAOI,
  showAddingAOI,
  hideAddingAOI,
  hideAddingAOIandWipeCoords,
  hideAddingPOIAndWipeCoords,
  showVehicleList,
  hideVehicleList,
  showPopup,
  hidePopup,
  summaryMapManage,
  changeAlertListType,
  showDetailsSidebarLoader,
  hideDetailsSidebarLoader,
  hideAddingPOI,
  showAddingPOI,
  setActivePageSuccess,
  setActiveCarDetailsView,
  showZones,
  showAlerts
};



// WEBPACK FOOTER //
// ./src/Redux/Actions/ViewManagementActions.ts